<template>
  <!-- <el-select v-model="selected" placeholder="請選擇" @change="getNote(selected)">
    <el-option
      v-for="(item,index) in options"
      :label="item.note"
      :value="item.note">
    </el-option>
  </el-select> -->
  <select
    v-model="selected"
    class="form-control fontSize16"
    @change="selectNote(selected)"
  >
    <option :value="-1">請選擇</option>
    <option v-for="(option, index) in options" v-bind:value="index">
      {{ option.note }}
    </option>
  </select>
</template>
<script>
import { cookies } from '@/utils/cookies'
import NoteAPI from '../../assets/js/libs/FirebaseAPI/Note'

export default {
  props: ['data'],
  data() {
    return {
      selected: -1,
      presetIndex: 1,
      isGetAPI: false,
      options: [
        { note: '部車' },
        { note: '簽車單' },
        { note: '需開收據' },
        { note: '需載行李' },
        { note: '統一超商' },
        { note: '全家超商' },
        { note: '萊爾富超商' },
        { note: '持有博愛卡' },
        { note: '老人' },
        { note: '行動不便' },
        { note: '請按分鐘數補登資料' },
        { note: '加工區（需要拿行李）' },
      ],
    }
  },
  mounted() {
    this.getNoteAPI()
  },
  methods: {
    initial() {
      this.selected = -1
    },
    getNoteAPI() {
      if (this.isGetAPI) return
      let teamCode = cookies.get('GladTeamCode')
      NoteAPI.get('?code=' + teamCode)
        .then((res) => {
          this.isGetAPI = true
          this.options = []
          this.options = res.result
        })
        .catch((err) => {
          console.log(err)
        })
    },
    selectNote(selected) {
      if (this.selected === -1) return
      this.$emit('noteSelect', this.options[selected].note)
    },
    clearNote() {
      this.selected = -1
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/tool/customerNoteSelect.vue